module.exports = __webpack_public_path__ + "img/1_goje.ac92bc84.jpg";